import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function SocialProofSection() {
  const quotes = ['“My rings fit again after the first week.”', '“I stopped waking up with a swollen face.”', '“Jeans feel normal again — that was the win.”', '“Someone asked what changed… I didn’t even diet.”', '“I finally feel confident in photos again.”'];
  return <section className="py-20 bg-[#1B5E20] text-white overflow-hidden" data-id="element-240">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-241">
        <span className="text-[#10B981] font-bold uppercase tracking-wider text-sm" data-id="element-242">
          SOCIAL PROOF
        </span>
        <h2 className="text-3xl md:text-4xl font-bold mt-4 mb-12" data-id="element-243">
          Real Women. Real “I Feel Like Me Again” Moments
        </h2>

        <div className="flex flex-wrap justify-center gap-6" data-id="element-244">
          {quotes.map((quote, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white/10 backdrop-blur-sm px-6 py-4 rounded-full border border-white/10 flex items-center gap-3" data-id="element-245">
              <Star className="w-4 h-4 text-[#10B981] fill-current flex-shrink-0" data-id="element-246" />
              <span className="font-medium italic text-sm md:text-base" data-id="element-247">
                {quote}
              </span>
            </motion.div>)}
        </div>

        <div className="mt-12" data-id="element-248">
          <p className="text-[#10B981] font-bold text-lg" data-id="element-249">
            Join thousands of women starting their reset worldwide.
          </p>
        </div>
      </div>
    </section>;
}